import { render, staticRenderFns } from "./NirAmendmentsApplications.vue?vue&type=template&id=03d0eb0a&scoped=true&"
import script from "./NirAmendmentsApplications.vue?vue&type=script&lang=js&"
export * from "./NirAmendmentsApplications.vue?vue&type=script&lang=js&"
import style0 from "./NirAmendmentsApplications.vue?vue&type=style&index=0&id=03d0eb0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d0eb0a",
  null
  
)

export default component.exports